import locales, { type LocaleObject } from '~/config/locales'

export const useLanguageSwitch = () => {
  const i18n = useI18n()
  const currentLocaleObject = i18n.localeProperties.value
  const currentIsoCode =
    typeof currentLocaleObject.iso === 'string'
      ? currentLocaleObject.iso
      : undefined

  const getLocaleObjectsByCountry = (countryCode: string) => {
    return locales.filter((localeObject: LocaleObject) => {
      return getCountryCode(localeObject.iso) === countryCode
    })
  }

  const getLanguageCode = (iso: string) => {
    return iso?.split('-')[0]
  }

  const getCountryCode = (iso: string) => {
    return iso?.split('-')[1]
  }

  const isCurrent = (localeObject: LocaleObject) => {
    return localeObject.code === currentLocaleObject.code
  }

  const currentCountryCode = currentIsoCode
    ? getCountryCode(currentIsoCode)
    : undefined

  return {
    availableLocales: currentCountryCode
      ? getLocaleObjectsByCountry(currentCountryCode)
      : [],
    getCountryCode,
    getLanguageCode,
    isCurrent,
    currentIsoCode,
  }
}

export default useLanguageSwitch
